import { Product } from 'src/utils/helpers/product';
import { productMatchesSelectedTags } from 'src/utils/helpers/tag-filtering';

type UseFilterProductsQueryByTagsParams = {
  tagsFromParams: string[];
  perPage: number;
  products: Product[];
  totalCount: number;
  totalPages: number;
};

function filterProductsByTags(products: Product[], tagsFromParams: string[]): Product[] {
  return products.filter((product) => productMatchesSelectedTags(product, tagsFromParams));
}

export function useFilterProductsQueryByTags(
  params: UseFilterProductsQueryByTagsParams
): Omit<UseFilterProductsQueryByTagsParams, 'perPage' | 'tagsFromParams'> {
  const { products, totalCount, totalPages, perPage, tagsFromParams } = params;

  if (tagsFromParams.length) {
    const productsFilteredByTags = filterProductsByTags(products, tagsFromParams);
    const adjustedTotalPages = Math.ceil(productsFilteredByTags.length / perPage);

    return {
      products: productsFilteredByTags,
      totalCount: productsFilteredByTags.length,
      totalPages: adjustedTotalPages,
    };
  }

  return {
    products,
    totalCount,
    totalPages,
  };
}
